/* global RequestInit */
import React, { useState } from 'react';
import { parameterService } from '@/projects/platform/services/parameter-service';
import { parameterService as adminParameterService } from '@/projects/admin/services/parameter-service';
import ParameterDetails from './parameter-details';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {
  const [parentParams] = useState(() => createCustomStore({
    key: ['id'],
    load: parameterService.getParameters,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["id", "=", key];
      }
    },
    onLoading(loadOptions) {
      loadOptions.filter = [["ParentId", "=", null]]
    },
    insert: adminParameterService.createParameter,
    update: adminParameterService.updateParameter,
    remove: adminParameterService.deleteParameter,
    useDefaultSearch: true
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };
  const navigate = useNavigate();

  const goToEdit = (id: string) => {
    navigate(`/admin/parameter-definition/${id}`, { state: { id: id } })
  }

  return (
    <React.Fragment>
      <DataGridWrapper
        datasource={parentParams}
        permissonCode='Admin.Parameter.Parameter'
        onRowUpdating={handleRowUpdating}
        filterVisible={true}
        headerFilterVisible={true}
        remoteOperations={false}
        enableCustomToolbarContent={true}
        isAddNewBtn={true}
        navigateNewRecordPath='/admin/parameter-definition'
        editingConfig={{
          refreshMode: 'reshape',
          mode: 'row',
          allowDeleting: true,
          allowUpdating: true,
          confirmDelete: true,
          deleteMessageText: RemoveMessage('Parameter')
        }}
        masterDetail={ParameterDetails}
        columns={[
          { dataField: 'applicationName', caption: t('application') },
          { dataField: 'code', caption: t('name') },
          { dataField: 'description', caption: t('description') },
          { dataField: 'longDescription', caption: t('summary') }
        ]}
        buttonConfig={[
          {
            name: 'edit',
            icon: 'edit',
            onClick: function (e: any) {
              goToEdit(e.row?.data.id);
            },
          },
          {
            name: 'delete',
            icon: 'trash',
          }
        ]}
      />
    </React.Fragment>
  );
};

export default App;
